<template>
  <div class="audioCustomizer">
    <div class="commonParameters">

      <div class="field is-horizontal locale">
        <div class="field-label is-normal"><label class="label">{{$t('common.language')}}</label></div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <input class="input" type="text" placeholder="Locale" v-model="scenario.parameters.commonParameters.locale"/>
            </div>
          </div>
        </div>
      </div>
      <div class="field is-horizontal vendor">
        <div class="field-label is-normal"><label class="label">Generation vendor</label></div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <div class="select">
                <select v-model="scenario.parameters.voiceParameters.vendor">
                  <option value="yandex">Yandex</option>
                  <option value="google">Google</option>
                  <option value="azure">Azure</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="field is-horizontal voice">
        <div class="field-label is-normal"><label class="label">{{$t('common.voice')}}</label></div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <input class="input" type="text" placeholder="voiceName" v-model="scenario.parameters.voiceParameters.voiceName"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>

      <div v-for="answer of scenario.parameters.audio" class="answer_shell">
        <answer
          :answer-title=answer.title
          :answer-theme=answer.name
          :answer-words=generateWords(answer)
          v-bind:answer-audio.sync="answer.sounds"
          v-bind:answer-text.sync="answer.text"
          v-bind:answer-vendor.sync="scenario.parameters.voiceParameters.vendor"
          v-bind:answer-locale.sync="scenario.parameters.commonParameters.locale"
          v-bind:answer-speaker.sync="scenario.parameters.voiceParameters.voiceName"
          v-bind:answer-emotion.sync="answer.emotion"
          v-bind:answer-speed.sync="answer.speed"

          :is-saved=true
          :client=scenario.client

          @generateAudioHandler="setAudio"
          @deleteAudioHandler="deleteAudio"
        />
      </div>
    </div>
<!--    <div>-->
<!--      <scenario-bar-->
<!--        :name="name"-->
<!--        v-bind:is-saved=true-->
<!--        :is-ready=true-->
<!--        v-bind:scenario="scenario"-->
<!--        @set="setScenario"-->
<!--      />-->
<!--    </div>-->

    <div class = "scenarioBarShell">
      <tool-buttons
        :name="name"
        :scenario.sync="scenario"
        :campaign-id="campaignid"
        @set="setScenario"
        @setDefault="setScenario"
      />
    </div>

  </div>
</template>

<script>
    import Answer from './../Answer'
    import ToolButtons from '../konstruktor/ToolButtons'
    export default {
        name: 'AudioCustomizer',
        props: ['name', 'campaignid', 'pScenario'],
        components: {Answer, ToolButtons},
        data() {
            return {
                scenario: {
                    client: '',
                    parameters: {
                        commonParameters: {
                            locale: ''
                        },
                        voiceParameters: {
                            vendor: '',
                            voiceName: ''
                        },
                        audio: [

                        ]
                    }
                },
                voices: {
                    'Yandex': [
                        {
                            value: 'jane'
                        },
                        {
                            value: 'oksana'
                        },
                        {
                            value: 'alyss '
                        },
                        {
                            value: 'omazh'
                        },
                        {
                            value: 'zahar '
                        },
                        {
                            value: 'ermil '
                        }
                    ],
                    'Google': [

                    ],
                    'Azure': []
                }
            }
        },
        methods: {
            setScenario(value) {
                this.scenario = value
            },
            setAudio(data) {
                let answer = this.getAnswerObjByClass(data.theme)
                if (answer) {
                    if (data.type) {
                        let sound = {
                            type: data.type,
                            url: data.url,
                            param: data.paramName,
                            number: data.number
                        }
                        answer.sounds = answer.sounds || []
                        let audioTmp = []
                        audioTmp.push(sound)
                        for (let i = 0; i < answer.sounds.length; i++) {
                            audioTmp.push(answer.sounds[i])
                        }
                        audioTmp.sort((a, b) => (a.number > b.number) ? 1 : -1)
                        answer.sounds = audioTmp
                        console.log(this.scenario)
                    } else {
                        answer.sounds = []
                        console.log(this.scenario)
                    }
                }
            },
            deleteAudio(data) {
                let answer = this.getAnswerObjByClass(data.theme)
                if (answer) {
                    answer.sounds = []
                }
            },
            getAnswerObjByClass(answerTheme) {
                for (let i = 0; i < this.scenario.parameters.audio.length; i++) {
                    let answer = this.scenario.parameters.audio[i]
                    if (answer.name.toLocaleLowerCase() === answerTheme.toLowerCase()) {
                        return answer
                    }
                }
            },
            generateWords(answer) {
                let words = answer.words || answer.variants || ''
                if (typeof words === 'string' || words instanceof String) {
                    if (words.length && words.indexOf('(') < 0) {
                        words = '(' + words + ')'
                    }
                    return words
                } else if (Array.isArray(words)) {
                    return '(' + words.join(', ') + ')'
                }
            }
        },
        mounted() {
          this.setScenario(this._props.pScenario)
        }
    }
</script>

<style scoped>

  /*.audioCustomizer {*/
  /*  margin-top: -45px;*/
  /*}*/

  .answer_shell {
    max-width: 777px;
    width: 44%;
    display: inline-block;
    margin-right: 32px;
    margin-top: 50px;
    vertical-align: top;
    /*border: 1px double black; !* Параметры границы *!*/
    background-color: ghostwhite;
    padding: 10px;
  }

  .answer_shell.start textarea{
    height: 64px;
    min-height: 64px;
  }

  .commonParameters {
    display: flex;
  }

  .commonParameters .locale input {
    max-width: 64px;
  }

  .commonParameters .vendor, .commonParameters .voice {
    margin-left:40px
  }

  .commonParameters .is-horizontal {
    display:flex;
  }

  .is-horizontal .field-label , .is-horizontal .field-body{
    display: inline-block;
  }

  .field-label {
    margin-top: 6px;
    margin-right: 2px;
  }


</style>

<style>
  .audioCustomizer .answer .generation_radios {
    display: none;
  }
  .audioCustomizer .generation_radios {
    display: none;
  }
  .audioCustomizer input[type=range].slider.is-small {
    width: 110px;
  }
  .audioCustomizer .generate_audio_control {
    margin-top: 10px;
  }

  /*.audioCustomizer .player {*/
  /*  width: 85%;*/
  /*  max-width: 420px;*/
  /*}*/
  .audioCustomizer .player .player-progress {
    max-width: 400px;
    width: 400px;
  }

  .audioCustomizer .player .volume input {
    width:53px;
  }

  .audioCustomizer .start textarea{
    height: 56px;
    min-height: 56px;
  }

  .active_scenario_universal.is-saved .choose_scenario {
    display: none;
  }

  .audioCustomizer .deleteAudio {
    display:none;
  }

  .audioCustomizer .answer .speaker {
    display: none;
  }

  /*.audioCustomizer .saveScenarioButton .saveScenarioButton {*/
  /*  display:none;*/
  /*}*/

  .audioCustomizer .scenarioBarShell {
    position: fixed;
    top: 23px;
    right: 20px;
    z-index: 1000;
    max-height: 73px;
    min-width: 160px;
    background-color: white;
    /*width: 100%;*/
  }

  .audioCustomizer.scrolled .scenarioBarShell {
    top: 7px;
    right: 460px;
    z-index: 10000;
    max-height: 32px;
  }
</style>



// WEBPACK FOOTER //
// AudioCustomizer.vue?6935c0c8